import React, { useState, useEffect } from "react";
import classes from "./Main.module.css";
import Chart from "react-apexcharts";
import photo from "../../Assets/admin.jpg";
import startPoint from "../../Assets/Pin_icon_green50.png";
import studentDummyImage from "../../Assets/new_student_marker.png";
import { useHistory } from "react-router-dom";
import useHttp from "../../Hooks/use-http";
import Loading from "../../Loading/Loading";
import little from "../../Assets/little.gif";
import TodayShiftIcon from "../../Assets/TodayShift.png";
import ActiveShiftIcon from "../../Assets/ActiveShift.png";
import ActiveTripIcon from "../../Assets/ActiveTrip.png";
import CurrentMonthTripIcon from "../../Assets/CurrentMonthTrip.png";
import CurrentMonthKmIcon from "../../Assets/CurrentMonthKm.png";
import LiveTrip from "./LiveTrip";
// import DriverData from "../PrivateDriver/DriverData";
import DriversData from "../Live Tracking/DriversData";
import TripDistanceRoundOff from "../CommonComponent/TripDistanceRoundOff";
// import studentDummyImage from "../../Assets/new_student_marker.png";

let divFlag = 0;
let driverList = [];
let initial;

const Main = (props) => {
  // const [options, setOptions] = useState(initial);
  const [isRender, setIsRender] = useState();
  const [listData, setListData] = useState({});
  const [isApiError, setIsApiError] = useState();
  const [isSwitchedToPrivateDriver, setIsSwitchedToPrivateDriver] =
    useState(false);
  const [todayShifts, setTodayShifts] = useState({
    completed: 0,
    total: 0,
    started: 0,
    ended: 0,
    pending: 0,
  });
  const [activeShifts, setActiveShifts] = useState({
    started: 0,
    ended: 0,
  });
  const [isShiftsLoading, setIsShiftsLoading] = useState(false);
  const history = useHistory();

  useEffect(() => {
    // alert("hello")
    if (
      localStorage.getItem("privateDriverFlag") == "true" &&
      !isSwitchedToPrivateDriver
    )
      document.getElementById("checkbox")?.click();
    // localStorage.setItem("privateDriverFlag", "false");
  }, []);

  useEffect(() => {
    let sessionInterval = null;

    function clearSessionTimeout() {
      initial = Math.round(new Date().getTime() / 1000);
    }

    function startSessionTime() {
      initial = Math.round(new Date().getTime() / 1000);
      sessionInterval = setInterval(() => {
        let current = Math.round(new Date().getTime() / 1000);
        if (current - initial > 1800) {
          if (sessionInterval) {
            clearInterval(sessionInterval);
            sessionInterval = null;
          }
          window.removeEventListener("mousemove", clearSessionTimeout);
          localStorage.setItem("login", false);
          sessionStorage.setItem("splashFlag", 0);
          history.push("/");
          setTimeout(() => {
            alert("Your session has been expired");
          }, 1000);
        }
      }, 60000);
    }

    startSessionTime();
    window.addEventListener("mousemove", clearSessionTimeout);

    // Cleanup function - CRITICAL for preventing memory leaks
    return () => {
      if (sessionInterval) {
        clearInterval(sessionInterval);
        sessionInterval = null;
      }
      window.removeEventListener("mousemove", clearSessionTimeout);
    };
  }, [history]);

  setTimeout(() => {
    if (document.getElementById("splash")) {
      document.getElementById("splash").style.display = "none";
      sessionStorage.setItem("splashFlag", "1");
    }
  }, 2000);

  const authenticateUser = (data) => {
    if (data.status !== 200) {
      setIsApiError("No data available");
    } else {
      let myData = {
        // tripKm: Math.ceil(data.TripKilometers / 1000),
        tripKm: data?.TripKilometers,
        trips: data.TripCount,
        activeTrips: data.ActiveTrip,
      };
      setListData(myData);
    }
  };

  const handleTodayShifts = (data) => {
    try {
      // API returns data.shifts array (raw API response)
      const shifts = data?.shifts || [];

      if (shifts && Array.isArray(shifts) && shifts.length > 0) {
        let startedCount = 0;
        let endedCount = 0;
        let pendingCount = 0;

        shifts.forEach((shift) => {
          // Check if cancelled - skip cancelled shifts (same logic as shifts table)
          const isCancelled =
            shift.cancelledOn != null ||
            shift.status?.toLowerCase() === "cancelled";
          if (isCancelled) {
            return;
          }

          // Use the same status logic as shifts table
          // Check status using startedOn and endedOn from raw API response
          const hasStartedOn =
            shift.startedOn != null && shift.startedOn !== "";
          const hasEndedOn = shift.endedOn != null && shift.endedOn !== "";
          const statusLower = shift.status?.toLowerCase();

          // Check if ended: both started and ended are present OR status is "ended"
          const isEnded =
            (hasStartedOn && hasEndedOn) || statusLower === "ended";

          // Check if started: started but not ended OR status is "started"
          const isStarted =
            (hasStartedOn && !hasEndedOn) || statusLower === "started";

          // Default to pending: neither started nor ended OR status is "pending"
          const isPending =
            (!hasStartedOn && !hasEndedOn) || statusLower === "pending";

          if (isEnded) {
            endedCount++;
          } else if (isStarted) {
            startedCount++;
          } else if (isPending) {
            pendingCount++;
          }
        });

        // Numerator: started + ended (shifts that have started, whether ended or not)
        const completed = startedCount + endedCount;
        // Denominator: started + pending + ended (all non-cancelled shifts)
        const total = startedCount + pendingCount + endedCount;

        setTodayShifts({
          completed,
          total,
          started: startedCount,
          ended: endedCount,
          pending: pendingCount,
        });

        // Active shifts: only started and ended (for the parallel section)
        setActiveShifts({
          started: startedCount,
          ended: endedCount,
        });
      } else {
        setTodayShifts({
          completed: 0,
          total: 0,
          started: 0,
          ended: 0,
          pending: 0,
        });
        setActiveShifts({ started: 0, ended: 0 });
      }
    } catch (error) {
      console.error("Error processing shifts data:", error);
      setTodayShifts({
        completed: 0,
        total: 0,
        started: 0,
        ended: 0,
        pending: 0,
      });
      setActiveShifts({ started: 0, ended: 0 });
    }
    setIsShiftsLoading(false);
  };

  const { isLoading, sendRequest } = useHttp();

  useEffect(() => {
    // debugger;
    if (sessionStorage.getItem("interval")) {
      clearInterval(sessionStorage.getItem("interval"));
      sessionStorage.removeItem("interval");
    }
  });

  useEffect(() => {
    // alert("jay");
    // if (divFlag % 2 === 0)
    sendRequest(
      {
        // url: "/api/v1/Dashboard/GetDashboard",
        url: "/dashboard",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
          roleID: localStorage.getItem("roleId"),
          corporateID: localStorage.getItem("corpId") || "",
        },
      },
      authenticateUser
    );
    divFlag++;
  }, [sendRequest]);

  // Fetch today's shifts
  useEffect(() => {
    setIsShiftsLoading(true);
    const today = new Date();
    const todayStr = `${today.getFullYear()}/${
      today.getMonth() + 1
    }/${today.getDate()}`;

    sendRequest(
      {
        url: "/shifts",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
          data: {
            filter: {
              corporateID:
                localStorage.getItem("roleId") != "1"
                  ? localStorage.getItem("corpId") || ""
                  : "",
              startDate: todayStr,
              endDate: todayStr,
            },
          },
        },
      },
      handleTodayShifts
    );
  }, [sendRequest]);

  return (
    <React.Fragment>
      <div className={classes.container} id="myContainer">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
          }}
        >
          <header>
            <div className={classes.cardContainer}>
              {/* Today's Shifts Section */}
              <div>
                <div
                  style={{
                    width: "auto",
                    height: "auto",
                    alignSelf: "center",
                    marginRight: "16px",
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={TodayShiftIcon}
                    alt="Today's Shift"
                    style={{
                      width: "38px",
                      height: "38px",
                      objectFit: "contain",
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "85%",
                    minWidth: 0,
                    display: "flex",
                    flexDirection: "column",
                    height: "auto",
                    cursor: "pointer",
                  }}
                  onClick={() => history.push("/privatedrive/shifts")}
                >
                  <span
                    style={{
                      fontFamily: "Poppins",
                      fontWeight: "normal",
                      fontSize: "14px",
                      whiteSpace: "nowrap",
                      color: "grey",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "100%",
                    }}
                  >
                    Today's Shifts
                  </span>
                  <span
                    style={{
                      fontFamily: "Poppins",
                      fontWeight: "500",
                      fontSize: "18px",
                      height: "50%",
                    }}
                  >
                    <span style={{ fontFamily: "Poppins", fontWeight: "bold" }}>
                      {todayShifts.total}
                    </span>
                  </span>
                </div>
              </div>

              {/* Active Shifts Section - Parallel to Today's Shifts */}
              <div>
                <div
                  style={{
                    width: "auto",
                    height: "auto",
                    alignSelf: "center",
                    marginRight: "16px",
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={ActiveShiftIcon}
                    alt="Active Shift"
                    style={{
                      width: "48px",
                      height: "48px",
                      objectFit: "contain",
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "85%",
                    minWidth: 0,
                    display: "flex",
                    flexDirection: "column",
                    height: "auto",
                    cursor: "pointer",
                  }}
                  onClick={() => history.push("/privatedrive/shifts")}
                >
                  <span
                    style={{
                      fontFamily: "Poppins",
                      fontWeight: "normal",
                      fontSize: "14px",
                      color: "grey",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "100%",
                    }}
                  >
                    Active Shifts
                  </span>
                  <span
                    style={{
                      fontFamily: "Poppins",
                      fontWeight: "500",
                      fontSize: "18px",
                      height: "50%",
                    }}
                  >
                    <span style={{ fontFamily: "Poppins", fontWeight: "bold" }}>
                      {activeShifts.started + activeShifts.ended}
                    </span>
                  </span>
                </div>
              </div>

              {/* Active Trips - Keep as is */}
              <div>
                <div
                  style={{
                    width: "auto",
                    height: "auto",
                    alignSelf: "center",
                    marginRight: "16px",
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={ActiveTripIcon}
                    alt="Active Trip"
                    style={{
                      width: "42px",
                      height: "42px",
                      objectFit: "contain",
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "85%",
                    minWidth: 0,
                    display: "flex",
                    flexDirection: "column",
                    height: "auto",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Poppins",
                      fontWeight: "normal",
                      color: "grey",
                      fontSize: "14px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "100%",
                    }}
                  >
                    Active Trips
                  </span>
                  <span
                    style={{
                      fontFamily: "Poppins",
                      fontWeight: "500",
                      fontSize: "18px",
                      height: "50%",
                    }}
                  >
                    <span style={{ fontFamily: "Poppins", fontWeight: "bold" }}>
                      {listData.activeTrips || 0}
                    </span>
                  </span>
                </div>
              </div>
              <div>
                <div
                  style={{
                    width: "auto",
                    height: "auto",
                    alignSelf: "center",
                    marginRight: "16px",
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={CurrentMonthTripIcon}
                    alt="Current Month Trip"
                    style={{
                      width: "38px",
                      height: "38px",
                      objectFit: "contain",
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "85%",
                    minWidth: 0,
                    display: "flex",
                    flexDirection: "column",
                    height: "auto",
                    cursor: "pointer",
                  }}
                  onClick={() => history.push("/trips")}
                >
                  <span
                    style={{
                      fontFamily: "Poppins",
                      fontWeight: "normal",
                      color: "grey",
                      fontSize: "14px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "100%",
                    }}
                  >
                    Current Month Trips
                  </span>
                  <span
                    style={{
                      fontFamily: "Poppins",
                      fontWeight: "500",
                      fontSize: "18px",
                      height: "50%",
                    }}
                  >
                    <span style={{ fontFamily: "Poppins", fontWeight: "bold" }}>
                      {listData.trips || 0}
                    </span>
                  </span>
                </div>
              </div>
              <div>
                <div
                  style={{
                    width: "auto",
                    height: "auto",
                    alignSelf: "center",
                    marginRight: "16px",
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={CurrentMonthKmIcon}
                    alt="Current Month Km"
                    style={{
                      width: "38px",
                      height: "38px",
                      objectFit: "contain",
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "85%",
                    minWidth: 0,
                    display: "flex",
                    flexDirection: "column",
                    height: "auto",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Poppins",
                      fontWeight: "normal",
                      fontSize: "14px",
                      color: "grey",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "100%",
                    }}
                  >
                    Current Month KM
                  </span>
                  <span
                    style={{
                      fontFamily: "Poppins",
                      fontWeight: "500",
                      fontSize: "18px",
                      height: "50%",
                    }}
                  >
                    <span style={{ fontFamily: "Poppins", fontWeight: "bold" }}>
                      {listData.tripKm || 0}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </header>
          <div style={{ height: "90%" }}>
            <DriversData />
          </div>
        </div>
      </div>
      {!sessionStorage.getItem("splashFlag") && (
        <div
          id="splash"
          style={{
            position: "fixed",
            backgroundColor: "white",
            top: -10,
            left: -12,
            right: 0,
            bottom: 0,
            height: "calc(100vh + 5px)",
            width: "100vw",
            zIndex: 99999,
            margin: 0,
            padding: 0,
            overflow: "hidden",
            boxSizing: "border-box",
          }}
        >
          <img
            src={little}
            style={{
              width: "100px",
              height: "150px",
              position: "absolute",
              top: "45%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          />
        </div>
      )}
    </React.Fragment>
  );
};

export default React.memo(Main);

// function distance(lat1,
//   lat2, lon1, lon2) {

//   // The math module contains a function
//   // named toRadians which converts from
//   // degrees to radians.
//   lon1 = lon1 * Math.PI / 180;
//   lon2 = lon2 * Math.PI / 180;
//   lat1 = lat1 * Math.PI / 180;
//   lat2 = lat2 * Math.PI / 180;

//   // Haversine formula
//   let dlon = lon2 - lon1;
//   let dlat = lat2 - lat1;
//   let a = Math.pow(Math.sin(dlat / 2), 2)
//     + Math.cos(lat1) * Math.cos(lat2)
//     * Math.pow(Math.sin(dlon / 2), 2);

//   let c = 2 * Math.asin(Math.sqrt(a));

//   // Radius of earth in kilometers. Use 3956
//   // for miles
//   let r = 6371;

//   // calculate the result
//   return (c * r * 1000);
// }
